import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport'
import { getMediumAssetPath } from '@aytm/lib/common/assets'
import {
  EcommerceBannerPlacement,
  EcommerceResponse,
  IEcommerceAnswerSchema,
  IEcommerceQuestionSchema
} from '../../types.ts'
import AssetsGate from '../../components/AssetsGate.tsx'
import ProductCard from './ProductCard.tsx'
import Spinner from './Spinner.tsx'
import style from './BannerAd.module.scss'

interface IBannerAdProps {
  schema: IEcommerceQuestionSchema
  bannerProducts: IEcommerceAnswerSchema[]
  response: EcommerceResponse
  findability: boolean
  onItemSelect: (index: number, bannerPlacement?: EcommerceBannerPlacement) => void
  onAddToCart: (index: number, qnt: number) => void
}

const BannerAd = ({ schema, bannerProducts, response, findability, onItemSelect, onAddToCart }: IBannerAdProps) => {
  const viewport = useViewport()
  // The band is a row of the grid, yet it waits for its own pictures, so it shows its own loader.
  const images = [
    schema.ad_image2 && getMediumAssetPath(schema.ad_image2),
    ...bannerProducts.map(answer => answer.image && getMediumAssetPath(answer.image))
  ]

  return (
    <AssetsGate urls={images} loader={<Spinner row />}>
      <section className={`${style.banner} ${viewport.mobile ? style.bannerMobile : ''}`} data-testid="SW-EC-Banner">
        {schema.ad_company_description && <p className={style.description}>{schema.ad_company_description}</p>}

        <div className={style.row}>
          {schema.ad_image2 && (
            <img src={getMediumAssetPath(schema.ad_image2)} alt="" role="presentation" className={style.adImage} />
          )}
          {bannerProducts.map(answer => (
            <div key={answer.id} className={style.item}>
              <ProductCard
                data-testid="SW-EC-BannerItem"
                schema={schema}
                answer={answer}
                amount={response.answers[answer.index].v}
                findability={findability}
                compact
                saveToList={false}
                disabled={false} // corpus rule: the ad placement sits outside the focus-mode gate (widget.md §Promo Banners)
                bannerPlacement="banner"
                onSelect={() => onItemSelect(answer.index, 'banner')}
                onAdd={qnt => onAddToCart(answer.index, qnt)}
              />
            </div>
          ))}
        </div>
      </section>
    </AssetsGate>
  )
}

export default BannerAd
